import { type ReactNode, useEffect } from 'react';
import triggerExcludes from '../../../utils/triggerExcludes';
import ESI from '../../ESI';
import { PAGE_LOAD } from '../../../utils/events';
import analyticsFactory from '../../../utils/analyticsFactory';
import layout from '../../../scss/layout.module.scss';

import {
  analyticsReady,
  dispatchImmediateAnalyticsEvent,
  setJLData,
  // @ts-expect-error TS(7016)
} from '@JohnLewisPartnership/jl-analytics';

import { parseCookies } from '../../../utils/cookies';

type ContentLayoutQuery = {
  excludeHeader?: string;
  excludeFooter?: string;
};

type ContentLayoutProps = {
  url?: string;
  query?: ContentLayoutQuery;
  children?: ReactNode;
};

function ContentLayout({ query, children, url }: ContentLayoutProps) {
  // Provide defaults as not available during build.
  const excludeHeader = query ? query.excludeHeader : 'false';
  const excludeFooter = query ? query.excludeFooter : 'false';

  const footerESI = '/esi/footer';

  useEffect(() => {
    const readyInterval = setInterval(() => {
      if (analyticsReady()) {
        clearInterval(readyInterval);
        const payload = analyticsFactory(url);
        const { shopperId } = parseCookies();

        setJLData({
          url,
          query,
          ...payload,
          ...(shopperId && {
            customer: {
              customerInfo: {
                loginStatus: 'recognised login',
                registrationStatus: 'existing registration',
                signinId: shopperId,
              },
            },
          }),
        });
        dispatchImmediateAnalyticsEvent(PAGE_LOAD, {});
      }
    }, 100);
  }, [url, query]);

  return (
    <>
      {!triggerExcludes(excludeHeader) && (
        <ESI
          id="header"
          src={`/scaffold/header.html?includeCoreJS=false&includePolyfills=false&includeCoreCSS=false&isWide=true`}
        />
      )}
      <main id="main" className={layout.main}>
        {children}
      </main>

      {!triggerExcludes(excludeFooter) && <ESI src={footerESI} id="footer" />}
    </>
  );
}

export default ContentLayout;
